import './index.css';
import { jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { LockClosedFilledSize16 } from '@hh.ru/magritte-ui-icon/icon';
import { enrichWithSkeleton } from '@hh.ru/magritte-ui-skeleton';
import { S as SwitchSkeleton, s as styles } from './Skeleton-C1pBA26p.js';

const SwitchComponent = ({ onClick, 'aria-label': ariaLabel, disabled = false, checked = false, ...props }) => {
    const forceDisabled = useDisabled();
    const switchClasses = classnames(styles.switch, {
        [styles.checked]: checked,
    });
    return (jsx("button", { ...props, type: "button", className: switchClasses, onClick: onClick, disabled: forceDisabled || disabled, "aria-checked": checked, "aria-label": ariaLabel, role: "switch", children: jsx("span", { className: styles.slider, children: (forceDisabled || disabled) && jsx(LockClosedFilledSize16, {}) }) }));
};
const Switch = enrichWithSkeleton(SwitchComponent, SwitchSkeleton);

export { Switch };
//# sourceMappingURL=Switch.js.map
